class SpectoUserLoginRegistration {

    constructor(validation = true) {
        this.jquerValidation = validation;
        this.bindEvents();
    }

    bindEvents() {
        $(document).on('click', '[data-action="userLoginBtn"]', {action : 'login'}, this.userValidate.bind(this));
        $(document).on('click', '[data-action="userRegistrationBtn"]', {action : 'registration'}, this.userValidate.bind(this));
        $(document).on('click', '[data-action="userResetPasswordBtn"]', {action : 'reset'}, this.userValidate.bind(this));
    }

    userValidate(e) {
        const action = e.data.action;
        const formEle = $('form[data-action="'+action+'"]');
        let that = this;
        if(this.jquerValidation) {
	        formEle.validate({
                rules: {
                	email: {
		                required: true,
		                email: true
	                },
	                username: {
		                required: true,
		                email: true
	                },
                    password: {
                    	required: true,
	                    minlength: 6
                    },
                    password_again: {
                        equalTo: "#password_register"
                    }
                },
		        messages: {
                	email: {
		                required: "Polje ne sme biti prazno",
		                email: "Prosimo vnesite veljaven email naslov"
	                },
                	username: {
		                required: "Polje ne sme biti prazno",
		                email: "Prosimo vnesite veljaven email naslov"
	                },
			        password: "Geslo je obvezno in mora vsebovati vsaj 6 znakov.",
			        password_again: "Geslo se ne ujema.",
		        },
                submitHandler: () => {
                    this.sendRequest(formEle, action);
                },
                // Custom Validation Styles
                invalidHandler: function(event, validator) {
                    const errors = validator.numberOfInvalids();
                    $('input.error').removeClass('error').parents('.form-group').removeClass('has-error');
                    if (errors) {
                        for(let item of validator.errorList) {
                            $(item.element).addClass('error').parents('.form-group').addClass('has-error');
                            if($(item.element).hasClass('css-checkbox'))
                                $(item.element).next().addClass('checkboxError');
	                        that.showErrors(validator.errorList[0].message, formEle);
                        }
                    }
                },
                showErrors: (errorMap, errorList) => {
                }
            });
        }
        else {
            e.preventDefault();
            this.sendRequest(formEle, action);
        }
    }

    sendRequest(formEle, action) {
        const data = formEle.serialize();
        $.ajax({
            method: 'POST',
            url: window.location.origin + '/api/v1/user/'+action,
            data: data
        })
        .done((res) => {
            if(action == 'reset'){
	            formEle.html('<p>Na elektronski naslov smo vam poslali zahtevo za resetiranje gesla.</p>');
                // $('#password').modal('hide');
                $(document).on('hide.bs.modal','#password', function () {
                    window.location.replace('/prijava');
                });
            } else
                window.location.replace('/prijava/paketi');
        })
        .fail((jqXHR) => {
            this.showErrors(jqXHR.responseJSON.msg, formEle);
            if(action === 'login'){
                formEle.find('input').addClass('error');
            }
        });
    }

    /**
     * Show Global Errors
     *
     * @param msg
     */
    showErrors(msg, formEle) {
	    formEle.find('.globalErrors').show();
	    formEle.find('.loadGlobalErrors').html(msg);
    }
}

$(document).ready(function () {
   new SpectoUserLoginRegistration();
});